export default "__VITE_ASSET__D2eazhur__"